import { render, staticRenderFns } from "./businessCenter.vue?vue&type=template&id=1023bbc1&scoped=true"
import script from "./businessCenter.vue?vue&type=script&lang=js"
export * from "./businessCenter.vue?vue&type=script&lang=js"
import style0 from "./businessCenter.vue?vue&type=style&index=0&id=1023bbc1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1023bbc1",
  null
  
)

export default component.exports